'use client';

import { Box, Stack } from '@mui/material';
import MasterLayout from '@/app/components/layout/master-layout';
import DeviceManageLayout from '@/app/components/layouts/device-manage';
import DropMessage from '../contact-us/drop-message';
import FaqAccordions from './faq-accordions';

export default function FaqsView() {
  return (
    <MasterLayout>
      <DeviceManageLayout title="FAQs" description="What do you want to know? We're here to help.">
        <Box
          sx={{
            mx: 'auto',
            width: {
              md: '100%',
              lg: '1200px',
            },
            pl: 3,
            pr: 3,
            pt: 6,
            pb: 6,
          }}
        >
          <Stack
            gap={8}
            justifyContent="space-around"
            sx={{
              flexDirection: {
                sm: 'column',
                md: 'row',
              },
            }}
          >
            <FaqAccordions />
            <DropMessage />
          </Stack>
        </Box>
      </DeviceManageLayout>
    </MasterLayout>
  );
}
